import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, effect} from '@angular/core';
import {
    AbstractControl,
    UntypedFormBuilder,
    UntypedFormControl,
    UntypedFormGroup,
    ValidatorFn,
    Validators,
} from '@angular/forms';
import { DateAdapter, MAT_DATE_FORMATS } from '@angular/material/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DD_MM_YYYY, HelperService, IdentifierService, MM_DD_YYYY, ToasterClass, YYYY_MM_DD } from 'merlin-core';
import {
    PopupConfig,
    PopupService,
    PopupType,
    SpinnerService,
    UserService,
} from 'merlin-library';
import { Mode } from '../../clinic-admin/clinic-users/services/clinic-users-data';
import { FrontEndErrMsgs } from '../enums/patient-device-data.enum';
import { CustomDateAdapter } from '../manual-patient-enroll/followup-schedule/customDateAdapter';
import { DateTimeService } from '../manual-patient-enroll/followup-schedule/date-time.service';
import { PICK_FORMATS } from '../manual-patient-enroll/followup-schedule/followup-schedule.component';
import {
    BaselineClinicalData,
    DropDownsModel,
    IndicationCode,
} from '../services/baseline-clinicaldata.model';
import { BaselineClinicalDataService } from '../services/baseline-clinicaldata.service';
import { ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import moment from 'moment';
import { LocalizationService, ReturnType } from 'src/core/utilitites/localization.service';
import { EnrollPatientDeviceDataService } from '../services/enroll-patient-device-data.service';
import { PatientListService } from '../services/patient-list.service';
import { ToastrService } from 'ngx-toastr';
import { ReleasePatientDialogComponent } from '../release-patient-dialog/release-patient-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { PatientProfilePrintDialogComponent } from '../patient-profile-print-dialog/patient-profile-print-dialog.component';
import { FunctionMode } from '../manual-patient-enroll/enums/enroll-patient.enum';

@Component({
    selector: 'app-baseline-clinical-data',
    templateUrl: './baseline-clinical-data.component.html',
    styleUrls: ['./baseline-clinical-data.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [
        DatePipe,
        DateTimeService,
        {
            provide: DateAdapter,
            useClass: CustomDateAdapter,
            deps: [DateTimeService],
        },
        { provide: MAT_DATE_FORMATS, useValue: PICK_FORMATS },
    ],
    standalone: false
})
export class BaselineClinicalDataComponent implements OnInit {
    @Input() public avaliableIds = [];
    @Input() public assignedIds = [];
    @Output() navForward = new EventEmitter();
    @Output() navBackward = new EventEmitter();
    @Input() patientid;
    @Input('functionMode') functionMode: string;
    displayMode: string = 'view';
    mainLocationId;
    mode = Mode.View;
    needConfirmationOnClose = true;
    submitted: boolean;
    isDisabled = true;
    nyhaList: any;
    pacemakerList: any;
    assignedIndications: any;
    availableIndications: any;
    baseLineInvalid: boolean;
    checkBoxFlag: boolean;
    textBoxFlag: boolean;
    bucketListFlag: boolean;
    nyhaDropDownFlag: boolean;
    public errorMsgs = [];
    public dataMsgs = [];
    public isError = false;
    public errorHeading;
    baselineClinicalData: BaselineClinicalData;
    userProfileData: any = {};
    date: Date;

    baselineClinicalDataFormGroup: UntypedFormGroup;
    baseLineDateError: string;
    hasPatientDataEntryAccess: boolean;
    isSP2CanEnroll: boolean;
    patRes;
    isPatientRelease: boolean = false;
    releasePatientMsg: string;
    dateRegex =
        '^((0?[1-9]|1[012])[-,.,\/](0?[1-9]|[12][0-9]|3[01])[-,.,\/](19|20)?[0-9]{4})*$';
    ddMMDateRegex =
        '^(0?[1-9]|[12][0-9]|3[01])[-,.,\/]((0?[1-9]|1[012])[-,.,\/](19|20)?[0-9]{4})*$';
    yyMMddRegex =
        '^((19|20)?[0-9]{4}[-,.,\/](0?[1-9]|1[012])[-,.,\/](0?[1-9]|[12][0-9]|3[01]))*$';
    dateFormat: string = 'MM-dd-yyyy';
    activatorClinicFlg: boolean = false;

    public stringLabels = [
        "label.gb.edit",
        "label.gb.baseline_clinical_data",
        "label.gb.button_cancel",
        "label.gb.save",
        "label.gb.print_profile",
        "label.gb.release_patient",
        "label.gb.more_actions",
        "label.gb.reactivate_pat",
        "label.gb.record_baseline_measurements",
        "label.gb.pacemaker_dependent",
        "label.gb.date_baseline_taken",
        "userProfileData.dateFormatLabel",
        "label.gb.HF_info",
        "label.gb.qrs_width",
        "label.gb.ms",
        "label.gb.ef",
        "label.gb.percentage",
        "label.gb.nyha_classification",
        "label.gb.nyha_classification",
        "label.gb.history",
        "label.gb.cardiovascular",
        "label.gb.angina",
        "label.gb.MI",
        "label.gb.PTCA",
        "label.gb.CABG",
        "label.gb.valve_disease",
        "label.gb.hypertension",
        "label.gb.arrhythmia",
        "label.gb.at",
        "label.gb.AF_paroxysmal",
        "label.gb.AR_chronic",
        "label.gb.afl",
        "label.gb.vt",
        "label.gb.vf",
        "label.gb.PVC",
        "label.gb.indications",
        "label.gb.required_field",
        "label.gb.back",
        "label.gb.button_cancel",
        "label.gb.continue"
    ];

    public labels: Record<string, string>;
    datePlaceholder: string;

    constructor(
        private formBuilder: UntypedFormBuilder,
        public dataService: BaselineClinicalDataService,
        private spinnerService: SpinnerService,
        private router: Router,
        private helperService: HelperService,
        private userService: UserService,
        public dateFormatService: DateTimeService,
        public datepipe: DatePipe,
        private translateService: TranslateService,
        private localizationService: LocalizationService,
        private route: ActivatedRoute,
        private enrollService: EnrollPatientDeviceDataService,
        public identifierService: IdentifierService,
        private patientListService: PatientListService,
        private toasterService: ToastrService,
        public dialog: MatDialog,
        public popupService: PopupService
    ) {
        effect(() => {
            const lang = this.localizationService.currentLang();
            if (!lang) return;
            this.labels = this.localizationService.reparseLocalizedStrings(this.labels);
        });
        this.generateForm();
    }
    ngOnDestroy() {
        this.enrollService.updateDeviceFormDirty(this.baselineClinicalDataFormGroup.dirty);
    }
    ngOnInit(): void {
        this.translateStrings();
        this.toasterService.clear();
        this.getUserProfileData();
        this.viewBaselineClinicalData();
        this.enrollService.updateDeviceFormDirty(false);
        this.baselineClinicalDataFormGroup.disable();
        this.baselineClinicalDataFormGroup.valueChanges.subscribe(() => {
            if (this.editMode() || this.functionMode == 'enroll') {
                this.enrollService.updateDeviceFormDirty(
                    this.baselineClinicalDataFormGroup.dirty
                );
                this.baselineClinicalDataFormGroup.enable({ emitEvent: false });
            }
        });
        //console.log('Display Mode,', this.functionMode);
        this.getPatRes();
    }

    translateStrings(){
        this.labels = this.localizationService.appendStringLabelsToRecord(this.labels, this.stringLabels);
    }

    generateForm() {
        this.baselineClinicalDataFormGroup = this.formBuilder.group({
            baseLineDate: new UntypedFormControl('', [
                baselineDateValidator(this.dateFormat),
            ]),
            pacemakerDependentCd: [''],
            qrsWidth: new UntypedFormControl('', [Validators.pattern('^[0-9]*$')]),
            ef: new UntypedFormControl('', [Validators.pattern('^[0-9]*$')]),
            nyhaClassificationCd: [''],
            anginaSelected: [''],
            patientId: [''],
            cardioCABGFlg: [''],
            cardioPTCAFlg: [''],
            cardioValveDiseaseFlg: [''],
            cardioHypertensionFlg: [''],
            arrhythmiaAtFlg: [''],
            arrhythmiaAFParoxysmalFlg: [''],
            arrhythmiaAFChronicFlg: [''],
            arrhythmiaAflFlg: [''],
            arrhythmiaVtFlg: [''],
            arrhythmiaVfFlg: [''],
            arrhythmiaPVCFlg: [''],
            indications: [''],
            miselected: [''],
            optionTransferAssignedIndications: [''],
        });
        //console.log('FIXING CONSOLE ISSUES')
    }

    rightSelectBoxUpdated_click(values) {
        if (!this.baselineClinicalDataFormGroup.dirty) {
            this.baselineClinicalDataFormGroup.markAsDirty();
        }
        let indicationArray = [];
        values.forEach((element) => {
            indicationArray.push({ indicationCd: element.codeId });
        });
        this.baselineClinicalDataFormGroup
            .get('indications')
            .setValue(indicationArray);
        if (values.length !== 0) {
            this.bucketListFlag = true;
        } else {
            this.bucketListFlag = false;
        }
        this.validateBaseLineDate();
    }

    viewBaselineClinicalData() {
        this.dataService.getData(this.patientid).subscribe(
            (res: BaselineClinicalData) => {
                //console.log(res);
                this.baselineClinicalData = res;
                this.bindFieldsData(res);

                const assignedIndicationId = res.indications?.map(
                    (indication: IndicationCode) => {
                        return indication.indicationCd;
                    }
                );
                this.availableIndications =
                    res.optionTransferAssignedIndications.filter(
                        (indication: DropDownsModel) => {
                            return !assignedIndicationId.includes(
                                indication.codeId
                            );
                        }
                    );
                this.assignedIndications =
                    res.optionTransferAssignedIndications.filter(
                        (indication: DropDownsModel) => {
                            return assignedIndicationId.includes(
                                indication.codeId
                            );
                        }
                    );
                this.availableIndications = this.availableIndications
                    .map((indication) => {
                        return {
                            ...indication,
                            label: this.getDDLabel(indication),
                        };
                    })
                    .sort((a, b) => {
                        const nameA = a.label.toUpperCase();
                        const nameB = b.label.toUpperCase();
                        if (nameA < nameB) {
                            return -1;
                        }
                        if (nameA > nameB) {
                            return 1;
                        }

                        return 0;
                    });
                this.assignedIndications = this.assignedIndications.map(
                    (indication) => {
                        return {
                            ...indication,
                            label: this.getDDLabel(indication),
                        };
                    }
                ).sort((a, b) => {
                    const nameA = a.label.toUpperCase();
                    const nameB = b.label.toUpperCase();
                    if (nameA < nameB) {
                        return -1;
                    }
                    if (nameA > nameB) {
                        return 1;
                    }

                    return 0;
                });
                this.baselineClinicalDataFormGroup
                    .get('baseLineDate')
                    .patchValue(
                        this.datepipe.transform(
                            new Date(res.baseLineDate),
                            this.dateFormat
                        )
                    );
                this.baselineClinicalDataFormGroup.patchValue({
                    ...res,
                    assignedIndications: this.assignedIndications,
                });
            },
            (error) => {
                this.helperService.showErrorToastr(error);
                this.spinnerService.visibility = false;
            }
        );
    }

    cancel() {
        this.router.navigate(['patient-list']);
    }

    resetForm() {
        const dialogConfig: PopupConfig = this.generatePopUpconfig(
            'msg.ad820.text',
            PopupType.Confirm
        );
        this.popupService.open(dialogConfig);
        this.popupService.dialogRef.afterClosed().subscribe((response: any) => {
            if (response) {
                this.needConfirmationOnClose = false;
                this.submitted = false;
                this.baselineClinicalDataFormGroup.reset();
                this.baselineClinicalDataFormGroup.disable();
                this.mode = Mode.View;
                this.isDisabled = true;
            }
        });
    }
    isBackActivate: boolean = false;
    back() {
        this.isBackActivate = true;
        // this.navBackward.emit('backward');
        this.submitForm();
    }

    submitForm() {
        // Normalize the baseLineDate value before submit
        const baseLineDateControl = this.baselineClinicalDataFormGroup.get('baseLineDate');
        if (baseLineDateControl && typeof baseLineDateControl.value === 'string') {
            const normalized = this.localizationService.normalizeDateFormat(baseLineDateControl.value);
            if (baseLineDateControl.value !== normalized) {
                baseLineDateControl.setValue(normalized, { emitEvent: false });
            }
        }
        this.formErrorHandling();
        if (!this.isError) {
            const endPoint: BaselineClinicalData =
                this.baselineClinicalDataFormGroup.getRawValue();
                this.spinnerService.visibility = true;
            this.dataService.updateData(endPoint).subscribe(
                (result: BaselineClinicalData) => {
                    if (this.functionMode !== FunctionMode.ENROLL) {
                        let successMsg =
                            this.localizationService.generateLocalizedStr(
                                'msg.cs830.text'
                            );
                        // this.toasterService.success(successMsg);
                        this.toasterService.show(successMsg, null, {
                            enableHtml: true,
                            toastClass: `${ToasterClass.userNotificationMessageB} ${ToasterClass.ngxToastr}`,
                            tapToDismiss: false
                        });
                    }
                    this.baselineClinicalDataFormGroup.markAsPristine();
                    this.spinnerService.visibility = false;
                    this.needConfirmationOnClose = false;
                    this.enrollService.updateDeviceFormDirty(false);
                    if (this.isBackActivate) {
                        this.navBackward.emit('backward');
                    } else {
                        this.navForward.emit('next');
                    }
                    this.displayMode = 'view';
                   this.baselineClinicalDataFormGroup.disable();
                    this.viewBaselineClinicalData();
                    // this.onCancelEditClick();
                },
                (error) => {
                    this.helperService.showErrorToastr(error);
                    this.spinnerService.visibility = false;
                }
            );
        }
        if (this.baselineClinicalDataFormGroup.get('baseLineDate').invalid) {
            const control =
                this.baselineClinicalDataFormGroup.get('baseLineDate');
            const baselineDate =
                this.baselineClinicalDataFormGroup.get('baseLineDate').value;
            if (control?.errors?.invalidDate) {
                const toastMsg = this.localizationService.generateLocalizedStr(
                    'msg.pa885.text',
                    null,
                    'html'
                );
                this.baselineClinicalDataFormGroup.get('baseLineDate').setErrors(null)
                this.toasterService.error(toastMsg, null, {
                    enableHtml: true,
                    disableTimeOut: true,
                    tapToDismiss: false
                });
            } else if (this.errorMsgs.length > 0) {
                let errMsg = this.errorHeading + '<ul>';
                this.errorMsgs.forEach((errItem: string) => {
                    errMsg = errMsg + '<li>' + errItem + '</li>';
                });
                errMsg = errMsg + '</ul>';
                this.toasterService.error(errMsg, null, {
                    enableHtml: true,
                    disableTimeOut: true,
                    tapToDismiss: false
                });
            } else {
                const errorHeading =
                    this.localizationService.generateLocalizedStr(
                        'msg.cs816.text',
                        { '0': '' },
                        'html'
                    );
                const field = this.labels['label.gb.date_baseline_taken'];
                const errorMsgAppendix = this.localizationService.generateLocalizedStr(
                    'msg.cs816.text_appendix',
                    { '0': this.datePlaceholder },
                    'html');
                const errorMsg = this.helperService.getErrorList([errorHeading, field, errorMsgAppendix]);
                this.toasterService.error(errorMsg, null, {
                    enableHtml: true,
                    disableTimeOut: true,
                    tapToDismiss: false
                });
            }
        } else if (
            this.baselineClinicalDataFormGroup.get('qrsWidth').invalid ||
            this.baselineClinicalDataFormGroup.get('ef').invalid
        ) {
            this.errorHeading = this.localizationService.generateLocalizedStr(
                'msg.cs816.text',
                { '0': '' }
            );
            const qrsWidth = this.baselineClinicalDataFormGroup.get('qrsWidth');
            const ef = this.baselineClinicalDataFormGroup.get('ef');
            if (qrsWidth?.errors?.pattern) {
                this.errorMsgs.push(
                    this.localizationService.generateLocalizedStr(
                        'label.gb.qrs_width'
                    )
                );
            }
            if (ef?.errors?.pattern) {
                this.errorMsgs.push(
                    this.localizationService.generateLocalizedStr('label.gb.ef')
                );
            }
            if (this.errorMsgs?.length) {
                const listError = this.getErrorList(
                    this.errorHeading,
                    this.errorMsgs
                );
                this.toasterService.error(listError, null, {
                    enableHtml: true,
                    disableTimeOut: true,
                    tapToDismiss: false
                });
            }
        }
    }
    getErrorList(title, errorMsgs) {
        let ulStr: any = '<span>' + title + '</span>' + '<br>';
        errorMsgs.forEach((err) => {
            if (err) {
                ulStr += '<span>' + err + '</span>' + '<br>';
            }
        });
        let x = document.createElement('span');
        x.innerHTML = ulStr;
        return x.innerHTML;
    }

    formErrorHandling() {
        this.isError = false;
        this.errorHeading = null;
        this.errorMsgs = [];
        this.baselineClinicalDataFormGroup.markAsDirty();

        this.baselineClinicalDataFormGroup.get('baseLineDate').setErrors({incorrectDate:null})
        this.baselineClinicalDataFormGroup.get('baseLineDate').updateValueAndValidity()

        // if(this.userProfileData.dateFormat == 'dd-MM-yyyy'){
        //     const dateRegex = /^\d{1,2}-\d{1,2}-\d{4}$/;
        //     if(!dateRegex.test(this.baselineClinicalDataFormGroup.get('baseLineDate').value)){
        //         this.baselineClinicalDataFormGroup.get('baseLineDate').setErrors({incorrectDate:true})
        //     }
        // }

        // if(this.userProfileData.dateFormat == 'yyyy-MM-dd'){
        //     const dateRegex = /^\d{4}-\d{1,2}-\d{1,2}$/;
        //     if(!dateRegex.test(this.baselineClinicalDataFormGroup.get('baseLineDate').value)){
        //         this.baselineClinicalDataFormGroup.get('baseLineDate').setErrors({incorrectDate:true})
        //     }
        // }
        if(this.baselineClinicalDataFormGroup?.get('baseLineDate')?.value?.trim()){
        const isValid = this.helperService.dateValidator(this.baselineClinicalDataFormGroup?.get('baseLineDate')?.value, this.userProfileData?.dateFormat);
        isValid ? null : this.baselineClinicalDataFormGroup?.get('baseLineDate')?.setErrors({incorrectDate:true})
        }
        if (this.baselineClinicalDataFormGroup.invalid) {
            for (let item in this.baselineClinicalDataFormGroup.controls) {
                this.errorHandling(
                    this.baselineClinicalDataFormGroup.controls[item],
                    item
                );
            }
            this.isError = true;
            return;
        }
    }

    errorHandling(controlItem, name) {
        if (isControlRequired(controlItem)) {
            this.isError = true;
            this.errorHeading = this.localizationService.generateLocalizedStr(
                FrontEndErrMsgs.reqHeading,
                { '0': '' },
                'html'
            );
            this.errorHeading = this.errorHeading
                .toString()
                .replace(/<br>/g, '');
            this.errorMsgs.push(
                this.localizationService.generateLocalizedStr(
                    FrontEndErrMsgs[name]
                )
            );
            this.errorMsgs = Array.from(new Set(this.errorMsgs));
        }
    }

    makeEditable() {
        this.baselineClinicalDataFormGroup.enable();
        this.mode = Mode.Edit;
        this.isDisabled = false;
    }

    getUserProfileData() {
        this.userService.getUserObs().subscribe((userData) => {
            if (userData) {
                this.activatorClinicFlg = userData.activatorClinicFlg;
                this.userProfileCallback(userData);
            } else {
                this.userService.getUserProfile(false).subscribe((userData) => {
                    this.userService.setUserObs(userData);
                    this.activatorClinicFlg =userData.activatorClinicFlg;
                    this.userProfileCallback(userData);
                });
            }
        });
    }
    userProfileCallback(userData) {
        this.dateFormatService.format = userData.dateFormat;
        this.dateFormat = userData.dateFormat;
        this.datePlaceholder = this.localizationService.translatePlaceHolder(this.dateFormat.toUpperCase());
        this.setValidationForBaseLineDate(false);
        this.userProfileData = userData;
        this.hasPatientDataEntryAccess = userData?.canEnroll;
        this.isSP2CanEnroll =
            userData.customerType === 'CL'
                ? true
                : userData?.customerType === 'SP2' && userData?.canEnroll;
    }
    requiredBasLineDate: boolean = false;
    setValidationForBaseLineDate(required: boolean) {
        let dRegex =
            this.userProfileData.dateFormat == 'dd-MM-yyyy'
                ? this.ddMMDateRegex
                : this.userProfileData.dateFormat == 'yyyy-MM-dd'
                ? this.yyMMddRegex
                : this.dateRegex;
        this.requiredBasLineDate = required;
        this.baselineClinicalDataFormGroup
            .get('baseLineDate')
            .clearValidators();
        if (required) {
            this.baselineClinicalDataFormGroup
                .get('baseLineDate')
                .setValidators([
                    Validators.pattern(dRegex),
                    Validators.required,
                    baselineDateValidator(this.dateFormat),
                ]);
        } else {
            this.baselineClinicalDataFormGroup
                .get('baseLineDate')
                .setValidators([
                    Validators.pattern(dRegex),
                    baselineDateValidator(this.dateFormat),
                ]);
        }
        this.baselineClinicalDataFormGroup
            .get('baseLineDate')
            .updateValueAndValidity();

        this.baselineClinicalDataFormGroup
            .get('baseLineDate')
            .markAsTouched();
    }

    onChange(event) {
        if (event.checked) {
            this.checkBoxFlag = true;
        } else {
            this.checkBoxFlag = false;
        }
        this.validateBaseLineDate();
    }

    onTextboxChange(event) {
        if (event.target.value) {
            this.textBoxFlag = true;
        } else {
            this.textBoxFlag = false;
        }
        this.validateBaseLineDate();
    }

    onDropDownChange(event) {
        if (event.value) {
            this.nyhaDropDownFlag = true;
        } else {
            this.nyhaDropDownFlag = false;
        }
        this.validateBaseLineDate();
    }

    validateBaseLineDate() {
        /* console.log(
            this.bucketListFlag,
            this.textBoxFlag,
            this.checkBoxFlag,
            this.nyhaDropDownFlag
        ); */
        let control = this.baselineClinicalDataFormGroup.get('baseLineDate');
        if (
            this.checkBoxFlag ||
            this.textBoxFlag ||
            this.bucketListFlag ||
            this.nyhaDropDownFlag
        ) {
            //  control.markAsTouched();
            this.baseLineInvalid = true;
            this.setValidationForBaseLineDate(true);
            const date = moment(
                control.value,
                this.userProfileData.dateFormat.toUpperCase()
            );
            const today = moment();
            if (date.isAfter(today)) {
                this.baselineClinicalDataFormGroup
                    .get('baseLineDate')
                    .setErrors({ invalidDate: true });
            } else {
                return null;
            }
        } else {
            if (control.value != '') {
                this.setValidationForBaseLineDate(false);
            } else {
                control.clearValidators();
                this.baseLineDateError = null;
                this.baseLineInvalid = false;
            }
        }
        control.updateValueAndValidity();
    }

    profileMode() {
        if (this.functionMode == 'profile') {
            return true;
        } else {
            return false;
        }
    }

    viewMode() {
        if (this.displayMode == 'view' && this.functionMode !== 'enroll') {
            return true;
        } else {
            return false;
        }
    }

    editMode() {
        if (this.displayMode == 'edit') {
            return true;
        } else {
            return false;
        }
    }

    setDisplayMode(value: string) {
        this.displayMode = value;
        if(this.displayMode === 'edit'){
            if (this.baselineClinicalDataFormGroup.disabled) {
                this.baselineClinicalDataFormGroup.enable({ emitEvent: false });
            }
        }else{
            if (this.baselineClinicalDataFormGroup.enabled) {
                this.baselineClinicalDataFormGroup.disable({ emitEvent: false });
            }
        }
    }

    onSaveButtonClick() {
        if (
            this.functionMode === 'profile' &&
            this.displayMode === 'edit' &&
            !this.baselineClinicalDataFormGroup.dirty
        ) {
            this.displayMode = 'view';
            this.baselineClinicalDataFormGroup.disable();
            return;
        }
        this.submitForm();
    }

    onCancelEditClick() {
        this.toasterService.clear();
    //     const dialogConfig: PopupConfig = this.generatePopUpconfig(
    //         'msg.cs834.text',
    //         PopupType.Confirm
    //     );
    //    if(this.baselineClinicalDataFormGroup.dirty){
    //     this.popupService.open(dialogConfig);
    //     this.popupService.dialogRef.afterClosed().subscribe((response: any) => {
    //         if (response) {
                this.viewBaselineClinicalData();
                this.displayMode = 'view';
                this.baselineClinicalDataFormGroup.disable();
                this.baselineClinicalDataFormGroup.markAsPristine();
                this.enrollService.updateDeviceFormDirty(false);
    //         }
    //     });
    // } else{
        // this.viewBaselineClinicalData();
        // this.displayMode = 'view';
    //}
    }

    showBaselineInputBox() {
        if (this.functionMode == 'enroll') {
            return true;
        } else if (
            this.functionMode == 'profile' &&
            this.displayMode == 'edit'
        ) {
            return true;
        }
    }

    showBaselineTextValue() {
        if (this.functionMode == 'profile' && this.displayMode == 'view') {
            return true;
        } else {
            return false;
        }
    }

    showBucketList() {
        if (this.functionMode == 'enroll') {
            return true;
        } else if (
            this.functionMode == 'profile' &&
            this.displayMode == 'edit'
        ) {
            return true;
        }
    }

    showIndicationsList() {
        if (this.functionMode == 'profile' && this.displayMode == 'view') {
            return true;
        } else {
            return false;
        }
    }

    enableUIElement() {
        if (this.functionMode == 'enroll') {
            return true;
        } else if (
            this.functionMode == 'profile' &&
            this.displayMode == 'edit'
        ) {
            return true;
        } else {
            return false;
        }
    }

    getPacemakerCd() {
        if(this.baselineClinicalData){
            let pacemakerCond = this.baselineClinicalData.pacemakerDependentCd;
            let codeId = this.baselineClinicalData?.pacemakerDependentList.filter((list:DropDownsModel)=> list?.codeId == pacemakerCond);
            return codeId?.length ?  this.getDDLabel(codeId[0]) : '';
        }
      return '';
    }

    translate(key: string): any {
        return this.localizationService.generateLocalizedStr(key);
    }
    onBlur($evnt) {
        this.validateBaseLineDate();
    }
    bindFieldsData(data) {
        this.route.params.subscribe((res) => {
            if (res?.id) {
                const fg = this.baselineClinicalDataFormGroup;
                fg.patchValue({
                    baseLineDate: data.baseLineDate,
                    pacemakerDependentCd: data.pacemakerDependentCd,
                    qrsWidth: data.qrsWidth,
                    ef: data.ef,
                    nyhaClassificationCd: data.nyhaClassificationCd,
                    anginaSelected: data.anginaSelected,
                    patientId: data.patientId,
                    cardioCABGFlg: data.cardioCABGFlg,
                    cardioPTCAFlg: data.cardioPTCAFlg,
                    cardioValveDiseaseFlg: data.cardioValveDiseaseFlg,
                    cardioHypertensionFlg: data.cardioHypertensionFlg,
                    arrhythmiaAtFlg: data.arrhythmiaAtFlg,
                    arrhythmiaAFParoxysmalFlg: data.arrhythmiaAFParoxysmalFlg,
                    arrhythmiaAFChronicFlg: data.arrhythmiaAFChronicFlg,
                    arrhythmiaAflFlg: data.arrhythmiaAflFlg,
                    arrhythmiaVtFlg: data.arrhythmiaVtFlg,
                    arrhythmiaVfFlg: data.arrhythmiaVfFlg,
                    arrhythmiaPVCFlg: data.arrhythmiaPVCFlg,
                    indications: data.indications,
                    miselected: data.miselected,
                    optionTransferAssignedIndications: data.optionTransferAssignedIndications
                }, { emitEvent: false });
            }
        });
    }

    reActivatePatient() {
        if (this.hasPatientDataEntryAccess) {
            this.patientListService
                .updateReactivatePatient([this.patientid])
                .subscribe(
                    (res) => {
                        this.toasterService.success(
                            this.localizationService.generateLocalizedStr(
                                'msg.pa800b.text',
                                { 0: '1' }
                            )
                        );
                        this.isPatientRelease = false;
                    },
                    (err) => {
                        this.helperService.showErrorToastr(err);
                    }
                );
        }
    }
    releasePatient() {
        const patientIds = [+this.patientid];

        this.patientListService.getReleasePatientData(patientIds).subscribe(
            (res) => {
                const releasePatientDRef = this.dialog.open(
                    ReleasePatientDialogComponent,
                    {
                        width: '900px',
                        // height:'600px',
                        data: {
                            patients: res.releasePatientSummaryDTO.map((a) => {
                                a.patientInfo['isTransmissionComplete'] =
                                    a.isTransmissionComplete;
                                return a.patientInfo;
                            }),
                            clinicFavoriteDTO: res.clinicFavoriteDTO,
                            releaseReasonCd: res.releaseReasonCd,
                            transferCustApplId: res.transferCustApplId,
                        },
                    }
                );

                releasePatientDRef.afterClosed().subscribe((result) => {
                    if (result.reasonForReasonFlag) {
                        const selectedIds = [this.patientid];
                        let data = {
                            patientIds: selectedIds,
                            releaseReasonCode: result.reasonForReasonFlag,
                            transferCustApplId: result.transferCustApplId
                                ? result.transferCustApplId
                                : '',
                        };
                        this.patientListService
                            .updateReleasePatient(data)
                            .subscribe((response) => {
                                const refTransferCusDetails =
                                    res.clinicFavoriteDTO &&
                                    res.clinicFavoriteDTO.find(
                                        (a) =>
                                            a.associatedCustApplId ===
                                            result.transferCustApplId
                                    );
                                let releasePatient =
                                    this.translateService.instant(
                                        'msg.pa834b.text'
                                    );

                                if (refTransferCusDetails) {
                                    releasePatient += ` ${refTransferCusDetails.name} : ${refTransferCusDetails.phoneNum} `;
                                }
                                if (result.reasonForReasonFlag === 'R'  &&
                                    result.selectedClinicDetails) {
                                        const phone = `${result.selectedClinicDetails.countryCode}-${result.selectedClinicDetails.areaCode}-${result.selectedClinicDetails.phoneNum}`;
                                    const releaseTxt =  this.activatorClinicFlg ? 'msg.patrel_actclinic.text' : 'msg.patrel_regclinic.text';
                                        releasePatient = result.selectedClinicDetails.customerId !=null
                                         ?
                                         this.translateMsg( releaseTxt,
                                            {
                                                0: result.selectedClinicDetails.name,
                                                1: phone,
                                            }, ReturnType.HTML
                                        ) : this.translateMsg('msg.pa834a.text', null, ReturnType.HTML);

                                        this.isPatientRelease = true;
                                        this.releasePatientMsg = releasePatient;

                                } else{
                                    this.isPatientRelease = false;
                                    this.releasePatientMsg = '';
                                }

                                if (this.profileMode()) {
                                    this.toasterService.success(
                                        this.localizationService.generateLocalizedStr(
                                            'msg.pa834b.text'
                                        )
                                    );
                                }
                            });
                    }
                });
            },
            (err) => {
                this.helperService.showErrorToastr(err);
            }
        );
    }

    translateMsg(key, params, returnType) {
        return this.localizationService.generateLocalizedStr(
            key,
            params,
            returnType
        );
    }
    openPrintDialog() {
        const dialogRef = this.dialog.open(PatientProfilePrintDialogComponent, {
            data: {
                patientid: this.patientid,
                patRes: this.patRes,
            },
        });
        dialogRef.afterClosed().subscribe((result) => {});
    }
    getPatRes() {
        this.enrollService
            .getDeviceData(this.functionMode, this.patientid.toString())
            .subscribe(
                (res) => {
                    this.patRes = res;
                },
                (err) => {
                    console.error(err);
                }
            );
    }
    getDDLabel(obj) {
        return this.localizationService.generateLocalizedStr(
            `data.Code.${obj.codeQualifier}.Code_Desc.${obj.code}`
        );
    }
    generatePopUpconfig(msgKey: string, popupType) {
        return {
            type: popupType,
            message: this.localizationService.generateLocalizedStr(
                msgKey,
                null,
                'html'
            ),
            confirmText:
                this.localizationService.generateLocalizedStr('label.gb.ok'),
            confirmId: this.identifierService.buttonId(
                'pcs-location-popup',
                'ok'
            ),
            cancelId: this.identifierService.buttonId(
                'pcs-location-popup',
                'cancel001'
            ),
            cancelText:
                popupType == PopupType.Confirm
                    ? this.localizationService.generateLocalizedStr(
                          'label.gb.button_cancel'
                      )
                    : '',
            customPopup: true,
        };
    }
}

export const isControlRequired = (control: AbstractControl): boolean => {
    if (!control) {
        return false;
    }

    if (control.validator) {
        const validator = control.validator({} as AbstractControl);
        if (validator && validator.required) {
            if (!control.value || control.value === '') {
                return true;
            } else {
                return false;
            }
        }
    }

    return false;
};


export function baselineDateValidator(e): ValidatorFn {
    return (control: UntypedFormControl): { [s: string]: boolean } | null => {
        if (!control.value || typeof control.value !== 'string') return null;

        const dateFormat = localStorage.getItem('dateFormat') || MM_DD_YYYY;
        const separators = ['-', '/', '.'];
        const separator = separators.find(sep => control.value.includes(sep));
        if (!separator) return { invalidDate: true };

        const str = control.value.split(separator);
        let day: number, month: number, year: number;

        switch (dateFormat) {
            case DD_MM_YYYY:
                [day, month, year] = [Number(str[0]), Number(str[1]), Number(str[2])];
                break;
            case YYYY_MM_DD:
                [year, month, day] = [Number(str[0]), Number(str[1]), Number(str[2])];
                break;
            case MM_DD_YYYY:
            default:
                [month, day, year] = [Number(str[0]), Number(str[1]), Number(str[2])];
                break;
        }

        // Pad day and month
        const paddedDay = day < 10 ? '0' + day : '' + day;
        const paddedMonth = month < 10 ? '0' + month : '' + month;

        // Build ISO string for parsing
        const finalDate = `${year}-${paddedMonth}-${paddedDay}T00:00:00.00Z`;
        const timestamp = Date.parse(finalDate);
        if (isNaN(timestamp)) return { invalidDate: true };

        const date = moment(new Date(timestamp), dateFormat.toUpperCase());
        const today = moment();

        // Check for future date
        if (date.isAfter(today)) return { invalidDate: true };

        return null;
    };
}
